import { Component, computed, Input, input, InputSignal, Signal } from '@angular/core';
import {
  ApplicationAppEntityApplicationRead,
  ShipmentAppEntityShipmentRead
} from '../../../../../openapi';
import { LabelComponent } from '../../../../../common/label/label.component';
import { CommonModule } from '@angular/common';
import { UploaderAttachmentsService } from '../../../../../services/uploader-attachments.service';
import { Store } from '@ngrx/store';
import {
  ApplicationPayment
} from '../../../../../services/application.common.model';
import { selectPayment } from '../../../../../store/selectors/application.selectors';
import { RouterModule } from '@angular/router';
import {
  AgreementsDataPreviewComponent
} from '../../common/agreements-data-section/components/agreements-data-preview/agreements-data-preview.component';
import {
  ApplicationDataPreviewComponent
} from '../../common/application-data-section/components/application-data-preview/application-data-preview.component';
import {
  AttachmentsDataPreviewComponent
} from '../../common/attachments-data-section/components/attachments-data-preview/attachments-data-preview.component';
import {
  OccupationPreviewComponent
} from '../../common/occupation-data-section/components/occupation-preview/occupation-preview.component';
import {
  RoadOccupationFormValue,
  occupationsToFormValue
} from '../../common/occupation-data-section/forms/road-occupation.form';
import {
  ApplicantPreviewComponent
} from '../../common/applicant-data-section/components/applicant-preview/applicant-preview.component';
import { DecisionDataPreviewComponent } from '../../common/decision-data-preview/decision-data-preview.component';
import {
  PaymentsDataPreviewComponent
} from '../../common/payments-data-section/components/payments-data-preview/payments-data-preview.component';
import {
  ContractorDataPreviewComponent
} from '../../common/contractor-data-section/components/contractor-data-preview/contractor-data-preview.component';

@Component({
  selector: 'app-carrying-out-works-preview',
  standalone: true,
  imports: [
    CommonModule,
    LabelComponent,
    OccupationPreviewComponent,
    RouterModule,
    AgreementsDataPreviewComponent,
    ApplicationDataPreviewComponent,
    AttachmentsDataPreviewComponent,
    ApplicantPreviewComponent,
    DecisionDataPreviewComponent,
    PaymentsDataPreviewComponent,
    ContractorDataPreviewComponent
  ],
  providers: [
    UploaderAttachmentsService
  ],
  templateUrl: './carrying-out-works-preview.component.html'
})
export class CarryingOutWorksPreviewComponent {

  @Input()
  public expanded: boolean = true;

  public application: InputSignal<ApplicationAppEntityApplicationRead | null> = input<ApplicationAppEntityApplicationRead | null>(null);

  public shipments: InputSignal<ShipmentAppEntityShipmentRead[]> = input<ShipmentAppEntityShipmentRead[]>([]);

  public canPay: InputSignal<boolean> = input<boolean>(false);

  public payment: Signal<ApplicationPayment | null> = this.store$.selectSignal(selectPayment);

  public roadOccupation: Signal<RoadOccupationFormValue | null> = computed(() => occupationsToFormValue(this.application()?.roadOccupations || []).at(0) || null);

  constructor(
    private store$: Store
  ) {
  }
}
